enum PopupActionTypes {
  POPUP_TRIGGER = "POPUP_TRIGGER",
}

export default PopupActionTypes
